import { Storybook } from "@tento-ui/ui/storybook";
import { CalendarCategorySelector } from "./calendar-category-selector";
import { EventCategory } from "@tento-lona";
import { STORYBOOK_EVENT_PRESENTATION } from "./storybook-presentation";

export class CalendarCategorySelectorStoryBook extends Storybook.Default {
  title(): string {
    return "Calendar Category Selector";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "All Selected",
        render: () => {
          const $selector = CalendarCategorySelector.make();
          const state = new CalendarCategorySelector.State(
            true,
            new Set<EventCategory>(),
          );
          const controller = new CalendarCategorySelector.Controller(
            state,
            () => {
              $selector.rebind();
            },
          );
          $selector.bind(controller, STORYBOOK_EVENT_PRESENTATION.categories);
          return $selector;
        },
      },
      {
        title: "Some Selected",
        render: () => {
          const $selector = CalendarCategorySelector.make();
          const selectedCategories = new Set<EventCategory>([
            "exercise",
            "food",
          ]);
          const state = new CalendarCategorySelector.State(
            false,
            selectedCategories,
          );
          const controller = new CalendarCategorySelector.Controller(
            state,
            () => {
              $selector.rebind();
            },
          );
          $selector.bind(controller, STORYBOOK_EVENT_PRESENTATION.categories);
          return $selector;
        },
      },
      {
        title: "Serialized State",
        render: () => {
          const $selector = CalendarCategorySelector.make();
          const state = new CalendarCategorySelector.State(true, new Set());
          const controller = new CalendarCategorySelector.Controller(
            state,
            (state) => {
              $status.bindText(JSON.stringify(state.serialize(), null, 2));
              $selector.rebind();
            },
          );
          const $status = Storybook.Card.StatusLine.make();
          $status.bindText(JSON.stringify(state.serialize(), null, 2));
          $selector.bind(controller, STORYBOOK_EVENT_PRESENTATION.categories);
          return {
            $content: $selector,
            $status,
          };
        },
      },
    ];
  }
}
